// extracted by mini-css-extract-plugin
module.exports = {"form":"CustomReadDates_form__1TEH8"};